import { render } from "./GameInfoContainer.vue?vue&type=template&id=cae721d6&scoped=true"
import script from "./GameInfoContainer.vue?vue&type=script&lang=js"
export * from "./GameInfoContainer.vue?vue&type=script&lang=js"

import "./GameInfoContainer.vue?vue&type=style&index=0&id=cae721d6&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cae721d6"]])

export default __exports__
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBanner,QBtn,QSeparator});
